<div class="flex w-full flex-col mt-2 px-6 sm:px-8">
    <p>Sync Diagram</p>
    <ejs-diagram width="100%" height="500px">
        <e-nodes>
            <e-node id='node1' [offsetX]="100" [offsetY]="100" [width]="100" [height]="100" [shape]="shape">
            </e-node>
            <e-node id='node2' [offsetX]="100" [offsetY]="100" [width]="100" [height]="100" [shape]="shape">
            </e-node>
            <e-node id='node3' [offsetX]="100" [offsetY]="100" [width]="100" [height]="100" [shape]="shape">
            </e-node>
            <e-node id='node4' [offsetX]="100" [offsetY]="100" [width]="100" [height]="100" [shape]="shape">
            </e-node>
        </e-nodes>
    </ejs-diagram>
</div>
